import { createAuthClient } from "better-auth/react";
import { dashClient } from "@better-auth/infra/client";

const baseURL = process.env.REACT_APP_BETTER_AUTH_URL || window.location.origin;

export const authClient = createAuthClient({
  baseURL,
  plugins: [dashClient()],
});
